import React, { useMemo, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Grid, Button, LinearProgress } from '@material-ui/core';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { isArray } from 'lodash';
import moment from 'moment';
import qs from 'querystring';

import IconExcel from '~/assets/icons/icons8-ms-excel.svg';
import { IconButton } from '~/components';
import { Autocomplete, Combobox, Select } from '~/components/Form';
import { t, number } from '~/helpers';
import { visualizarCO, generateReportGet } from '~/helpers/reportUtils';
import api from '~/services/api';
import { MODULO_CUSTOMIZACAO_RUMO } from '~/constants/modules';
import { Tabela } from './components';
import * as S from './styles';

function RelPitStopQuantidade() {
  const { language } = useSelector((state) => state.user);
  const { client } = useSelector((state) => state.user.profile);
  const [
    datahorainicialmovimentacao,
    setDatahorainicialmovimentacao,
  ] = React.useState(null);
  const [
    datahorafinalmovimentacao,
    setDatahorafinalmovimentacao,
  ] = React.useState(null);
  const [idagrupamento, setIdagrupamento] = React.useState('0');
  const [posto, setPosto] = React.useState(null);
  const [postoObj, setPostoObj] = useState(null);
  const [idbico, setIdbico] = React.useState(null);
  const [idveiculo, setIdveiculo] = React.useState(null);
  const [quantidades, setQuantidades] = React.useState([]);
  const [gravando, setGravando] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const modules = useSelector((state) => state.user.modules);
  const clienteRumo = modules.includes(MODULO_CUSTOMIZACAO_RUMO);

  const output = useMemo(() => 'DD/MM/YYYY HH:mm:ss', [language]);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const execucao = useMemo(
    () => [
      { label: '0', value: '' },
      { label: 'N', value: t('s.geral.opcoes.nao') },
      { label: 'S', value: t('s.geral.opcoes.sim') },
      { label: 'X', value: t('s.geral.opcoes.na') },
    ],
    []
  );

  const handleDateInicialChange = useCallback((data) => {
    if (data) {
      setDatahorainicialmovimentacao(data.format('YYYY-MM-DD HH:mm:ss'));
    } else {
      setDatahorainicialmovimentacao(null);
    }
  }, []);

  const handleDateFinalChange = useCallback((data) => {
    if (data) {
      setDatahorafinalmovimentacao(data.format('YYYY-MM-DD HH:mm:ss'));
    } else {
      setDatahorafinalmovimentacao(null);
    }
  }, []);

  const optionsAtendimento = useMemo(
    () =>
      clienteRumo
        ? [
            { value: '0', label: t('s.relatorio.geral.todos') },
            {
              value: '1',
              label: t('s.configuracao.produto.calculodensidadeproduto.diesel'),
            },
            { value: '2', label: t('s.geral.opcoes.lubrificante') },
            { value: '3', label: t('s.cadastro.pitstop.areia') },
            { value: '4', label: t('s.cadastro.pitstop.limpeza') },
            { value: '5', label: t('s.cadastro.pitstop.banheiro') },
          ]
        : [
            { value: '0', label: t('s.relatorio.geral.todos') },
            {
              value: '1',
              label: t('s.configuracao.produto.calculodensidadeproduto.diesel'),
            },
            { value: '2', label: t('s.geral.opcoes.lubrificante') },
            { value: '3', label: t('s.cadastro.pitstop.areia') },
            { value: '4', label: t('s.cadastro.pitstop.limpeza') },
            { value: '6', label: t('s.cadastro.pitstop.agua') },
          ],
    []
  );

  React.useEffect(() => {
    setIdagrupamento('0');
    setDatahorainicialmovimentacao(start.format('YYYY-MM-DD HH:mm:ss'));
    setDatahorafinalmovimentacao(end.format('YYYY-MM-DD HH:mm:ss'));
  }, []);

  const handlePesquisar = async () => {
    if (datahorainicialmovimentacao && datahorafinalmovimentacao) {
      if (
        datahorainicialmovimentacao.length != 19 ||
        datahorafinalmovimentacao.length != 19
      ) {
        toast.error(t('s.cadastro.pitstop.periodo-deve-ser-informado'));
        return;
      }
    } else {
      toast.error(t('s.cadastro.pitstop.periodo-deve-ser-informado'));
      return;
    }
    try {
      setGravando(true);

      const { data } = await api.get('/pitstop/relatorio/quantidade', {
        params: {
          datahorainicialmovimentacao,
          datahorafinalmovimentacao,
          idcliente: client,
          idposto: posto,
          idveiculo,
          idbico: idbico || null,
          idagrupamento,
        },
        paramsSerializer: (param) => qs.stringify(param),
      });
      const l = data.quantidadeVOs.map((quantidade) => ({
        ...quantidade,
      }));
      const list = l.map((row) => ({
        ...row,
      }));
      setQuantidades(list);

      setGravando(false);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
      setGravando(false);
    }
  };

  const handleExport = async (formato) => {
    if (datahorainicialmovimentacao && datahorafinalmovimentacao) {
      if (
        datahorainicialmovimentacao.length != 19 ||
        datahorafinalmovimentacao.length != 19
      ) {
        toast.error(t('s.cadastro.pitstop.periodo-deve-ser-informado'));
        return;
      }
    } else {
      toast.error(t('s.cadastro.pitstop.periodo-deve-ser-informado'));
      return;
    }
    try {
      setGravando(true);

      const datahorainicio = moment(
        datahorainicialmovimentacao,
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DDTHH:mm:ss');

      const datahorafim = moment(
        datahorafinalmovimentacao,
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DDTHH:mm:ss');

      let fieldlist = 'codigonomeposto,';
      const wherefield = ['dataencosteatendimento', 'dataliberacaoatendimento'];
      const typewherefield = ['MAIOR_IGUAL', 'MENOR_IGUAL'];
      const valuewherefield = [datahorainicio, datahorafim];
      const substituirHeader = {
        idveiculo: t('s.menu.cadastro.veiculo.locomotiva'),
      };

      let textoPesquisa = `FILTRO - ${t(
        's.geral.opcoes.datahorainicial'
      )}: ${moment(datahorainicialmovimentacao, 'YYYY-MM-DD HH:mm:ss').format(
        'DD/MM/YYYY HH:mm:ss'
      )} | ${t('s.geral.opcoes.datahorafinal')}: ${moment(
        datahorafinalmovimentacao,
        'YYYY-MM-DD HH:mm:ss'
      ).format('DD/MM/YYYY HH:mm:ss')}`;
      let filteruser = false;

      switch (idagrupamento) {
        case '1':
          fieldlist +=
            'datahorainicialmovimentacaoabastecimento, ' +
            'datahorafinalmovimentacaoabastecimento, duracaoabastecimento, ' +
            'codigoatendimento, idveiculo, idbicoabastecimento, ' +
            'volumemovimentacaoabastecimento, ' +
            'encerranteinicialmovimentacaoabastecimento, ' +
            'encerrantefinalmovimentacaoabastecimento';

          substituirHeader.duracaoabastecimento = t(
            'abastecidos.operacao.geolocalizacao.tempoabastecimento'
          );

          textoPesquisa += ` | Agrupamento: Diesel`;
          break;

        case '2':
          fieldlist +=
            'datahorainicialmovimentacaolubrificacao, ' +
            'datahorafinalmovimentacaolubrificacao, duracaolubrificacao, ' +
            'codigoatendimento, idveiculo, idbicolubrificacao, ' +
            'volumemovimentacaolubrificacao, ' +
            'encerranteinicialmovimentacaolubrificacao, ' +
            'encerrantefinalmovimentacaolubrificacao';
          if (!clienteRumo) {
            fieldlist +=
              ', volumegeradorlubrificacao, volumegovernadorlubrificacao, volumecompressorlubrificacao';
          }

          substituirHeader.duracaolubrificacao = t(
            'abastecidos.operacao.geolocalizacao.tempoabastecimento'
          );

          textoPesquisa += ` | Agrupamento: Lubrificante`;
          break;

        case '3':
          fieldlist +=
            'datainicioatendimentoareia, datafimatendimentoareia, ' +
            'duracaoareia, codigoatendimento, idveiculo, sacosatendimentoareia';

          substituirHeader.duracaoareia = t(
            'abastecidos.operacao.geolocalizacao.tempoabastecimento'
          );
          substituirHeader.sacosatendimentoareia = t(
            's.cadastro.pitstop.areia'
          );

          textoPesquisa += ` | Agrupamento: Areia`;
          break;

        case '4':
          fieldlist +=
            'datainicioatendimentolimpeza, datafimatendimentolimpeza, ' +
            'duracaolimpeza, codigoatendimento, idveiculo, ' +
            'vidroatendimentolimpeza, pisoatendimentolimpeza, ' +
            'painelatendimentolimpeza';
          fieldlist +=
            ', banheiroatendimentolimpeza, plataformaatendimentolimpeza';

          substituirHeader.duracaolimpeza = t(
            'abastecidos.operacao.geolocalizacao.tempoabastecimento'
          );

          textoPesquisa += ` | Agrupamento: Limpeza`;
          break;

        case '5':
          fieldlist +=
            'datainicioatendimentolimpeza, datafimatendimentolimpeza, ' +
            'duracaolimpeza, codigoatendimento, idveiculo, aguabanheiro, ' +
            'sanitariobanheiro';

          substituirHeader.duracaolimpeza = t(
            'abastecidos.operacao.geolocalizacao.tempoabastecimento'
          );

          textoPesquisa += ` | Agrupamento: Banheiro`;
          break;

        case '6':
          fieldlist +=
            'datainicioatendimentoagua, datafimatendimentoagua, duracaoagua, codigoatendimento, idveiculo';

          substituirHeader.duracaoagua = t(
            'abastecidos.operacao.geolocalizacao.tempoabastecimento'
          );

          textoPesquisa += ` | Agrupamento: Água`;
          break;

        default:
          fieldlist +=
            'dataencosteatendimento, dataliberacaoatendimento, ' +
            'duracaoatendimentodate, codigoatendimento, idveiculo, ' +
            'volumemovimentacaoabastecimento, sacosatendimentoareia, ' +
            'volumemovimentacaolubrificacao ';

          if (!clienteRumo) {
            fieldlist +=
              ', volumegeradorlubrificacao, ' +
              'volumegovernadorlubrificacao, ' +
              'volumecompressorlubrificacao';
          }

          substituirHeader.dataencosteatendimento = t(
            's.geral.opcoes.datahorainicial'
          );
          substituirHeader.dataliberacaoatendimento = t(
            's.geral.opcoes.datahorafinal'
          );
          substituirHeader.sacosatendimentoareia = t(
            's.cadastro.pitstop.areia'
          );
          substituirHeader.duracaoatendimentodate = t(
            'abastecidos.operacao.geolocalizacao.tempoabastecimento'
          );

          if (!clienteRumo) {
            substituirHeader.volumegeradorlubrificacao = t(
              's.relatorio.pitstopquantidades.gerador'
            );
            substituirHeader.volumegovernadorlubrificacao = t(
              's.relatorio.pitstopquantidades.governador'
            );
            substituirHeader.volumecompressorlubrificacao = t(
              's.relatorio.pitstopquantidades.compressor'
            );
          }

          textoPesquisa += ` | Agrupamento: Todos`;
          break;
      }

      if (postoObj && postoObj.idposto && postoObj.codigonomeposto) {
        wherefield.push('idposto');
        typewherefield.push('EQUALS');
        valuewherefield.push(postoObj.idposto);

        const nomePosto = postoObj.codigonomeposto;
        textoPesquisa += ` | ${t('s.geral.postocomboio')}: ${nomePosto}`;

        if (
          idbico &&
          idbico > 0 &&
          (idagrupamento === '1' || idagrupamento === '2')
        ) {
          wherefield.push(
            idagrupamento === '1' ? 'idbicoabastecimento' : 'idbicolubrificacao'
          );
          valuewherefield.push(idbico);
          typewherefield.push('EQUALS');

          textoPesquisa += ` | ${t('s.menu.configuracao.bico')}: ${idbico}`;
        }
      } else {
        filteruser = true;
      }

      if (idveiculo && idveiculo.length > 0) {
        wherefield.push('idveiculo');
        valuewherefield.push(idveiculo);
        typewherefield.push('EQUALS');

        textoPesquisa += ` | ${t(
          's.menu.cadastro.veiculo.locomotiva'
        )}: ${idveiculo}`;
      }

      const reportRequestParams = {
        fieldlist,
        wherefield,
        typewherefield,
        valuewherefield,
        filteruser,
        orderfield: 'dataencosteatendimento',
        ordination: 'asc',
        relatorio: {
          formato,
          custom: true,
          tituloRelatorio: t('s.relatorio.pitstop.quantidades'),
          substituirHeader,
          textoPesquisa,
        },
      };

      await generateReportGet({
        endpoint: `pitstop`,
        params: reportRequestParams,
      });
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else if (typeof err === 'string') {
        toast.error(t(err));
      } else {
        console.log(err);
      }
    } finally {
      setGravando(false);
    }
  };

  const cellQuantidade = React.useMemo(() => {
    const data = [
      {
        id: 'idatendimento',
        label: '',
      },
      {
        id: 'nomeposto',
        label: t('s.menu.configuracao.posto'),
      },
      {
        id: 'datahorainincio',
        label: t('s.cadastro.pitstop.dataencosteatendimento'),
      },
      {
        id: 'datahorafim',
        label: t('s.cadastro.pitstop.dataliberacaoatendimento'),
        align: 'left',
      },
      {
        id: 'tempo',
        label: t('abastecidos.operacao.geolocalizacao.tempoabastecimento'),
      },
      {
        id: 'co',
        label: t('s.cadastro.pitstop.codigoatendimento'),
      },
      {
        id: 'locomotiva',
        label: t('s.menu.cadastro.veiculo.locomotiva'),
      },
    ];

    if (idagrupamento === '0') {
      // todos
      data.splice(7, 0, {
        id: 'diesel',
        label: t('s.configuracao.produto.calculodensidadeproduto.diesel'),
        align: 'right',
        format: (value) => number(value, 2),
      });
      data.splice(8, 0, {
        id: 'areia',
        label: t('s.cadastro.pitstop.areia'),
        align: 'right',
        format: (value) => number(value, 2),
      });
      data.splice(9, 0, {
        id: 'lubrificante',
        label: t('s.cadastro.pitstop.lubrificacao'),
        align: 'right',
        format: (value) => number(value, 2),
      });

      if (!clienteRumo) {
        data.splice(10, 0, {
          id: 'geradorlubrificacao',
          label: t('s.relatorio.pitstopquantidades.gerador'),
          align: 'right',
          format: (value) => number(value, 2),
        });
        data.splice(11, 0, {
          id: 'governadorlubrificacao',
          label: t('s.relatorio.pitstopquantidades.governador'),
          align: 'right',
          format: (value) => number(value, 2),
        });
        data.splice(12, 0, {
          id: 'compressorlubrificacao',
          label: t('s.relatorio.pitstopquantidades.compressor'),
          align: 'right',
          format: (value) => number(value, 2),
        });
      }
    }

    if (idagrupamento === '1' || idagrupamento === '2') {
      // abastecimento ou lubrificacao
      data.splice(7, 0, {
        id: 'idbico',
        label: t('s.menu.configuracao.bico'),
      });
      if (idagrupamento === '1') {
        data.splice(8, 0, {
          id: 'diesel',
          label: t('s.configuracao.produto.calculodensidadeproduto.diesel'),
          align: 'right',
          format: (value) => number(value, 2),
        });
      } else {
        data.splice(8, 0, {
          id: 'lubrificante',
          label: t('s.geral.opcoes.lubrificante'),
          align: 'right',
          format: (value) => number(value, 2),
        });
      }
      data.splice(9, 0, {
        id: 'encerranteinicial',
        label: t('s.geral.camposistema.encerranteinicialmovimentacao'),
        align: 'right',
        format: (value) => number(value, 2),
      });
      data.splice(10, 0, {
        id: 'encerrantefinal',
        label: t('s.geral.camposistema.encerrantefinalmovimentacao'),
        align: 'right',
        format: (value) => number(value, 2),
      });
    }

    if (idagrupamento === '2') {
      // lubrificacao
      if (!clienteRumo) {
        data.splice(11, 0, {
          id: 'geradorlubrificacao',
          label: t('s.relatorio.pitstopquantidades.gerador'),
          align: 'right',
          format: (value) => number(value, 2),
        });
        data.splice(12, 0, {
          id: 'governadorlubrificacao',
          label: t('s.relatorio.pitstopquantidades.governador'),
          align: 'right',
          format: (value) => number(value, 2),
        });
        data.splice(13, 0, {
          id: 'compressorlubrificacao',
          label: t('s.relatorio.pitstopquantidades.compressor'),
          align: 'right',
          format: (value) => number(value, 2),
        });
      }
    }

    if (idagrupamento === '3') {
      // areia
      data.splice(7, 0, {
        id: 'areia',
        label: t('s.cadastro.pitstop.areia'),
        align: 'right',
        format: (value) => number(value, 2),
      });
    }

    if (idagrupamento === '4') {
      // limpeza
      data.splice(7, 0, {
        id: 'vidroatendimentolimpeza',
        label: t('s.cadastro.pitstop.vidroatendimentolimpeza'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
      });
      data.splice(8, 0, {
        id: 'pisoatendimentolimpeza',
        label: t('s.cadastro.pitstop.pisoatendimentolimpeza'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
      });
      data.splice(9, 0, {
        id: 'painelatendimentolimpeza',
        label: t('s.cadastro.pitstop.painelatendimentolimpeza'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
      });
      data.splice(10, 0, {
        id: 'banheiroatendimentolimpeza',
        label: t('s.cadastro.pitstop.banheiroatendimentolimpeza'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
      });
      data.splice(11, 0, {
        id: 'plataformaatendimentolimpeza',
        label: t('s.cadastro.pitstop.plataformaatendimentolimpeza'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
      });
    }

    if (idagrupamento === '5') {
      // banheiro = rumo
      data.splice(7, 0, {
        id: 'aguabanheiro',
        label: t('s.cadastro.pitstop.aguabanheiro'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
      });
      data.splice(8, 0, {
        id: 'sanitariobanheiro',
        label: t('s.cadastro.pitstop.sanitariobanheiro'),
        format: (value) => execucao.find((s) => s.label === value).value || '',
      });
    }

    // para idagrupamento === '6' = agua - nada a acrecentar

    return data;
  }, [idagrupamento]);

  const handleImprimeCO = (idatendimento) => {
    visualizarCO(idatendimento, api.defaults.headers.token);
  };

  return (
    <>
      {gravando && <LinearProgress />}
      <S.DatePickerWrapper>
        <Grid
          container
          spacing={2}
          padding={2}
          alignItems="center"
          style={{ marginTop: '5px' }}
        >
          <Grid
            item
            xs={14}
            md={14}
            lg={14}
            container
            spacing={1}
            justifyContent="flex-start"
          >
            <>
              <Grid item xs={6} sm={12} md="auto">
                <S.DatePicker
                  name="datahorainicialmovimentacao"
                  ampm={false}
                  size="small"
                  inputVariant="outlined"
                  cancelLabel={t('s.geral.botaocancelar')}
                  format={output}
                  onChange={handleDateInicialChange}
                  value={datahorainicialmovimentacao}
                  KeyboardButtonProps={{ padding: 0 }}
                  invalidDateMessage=""
                />
              </Grid>
              <Grid item xs={6} sm={12} md="auto">
                <S.DatePicker
                  name="datahorafinalmovimentacao"
                  size="small"
                  ampm={false}
                  inputVariant="outlined"
                  cancelLabel={t('s.geral.botaocancelar')}
                  format={output}
                  onChange={handleDateFinalChange}
                  value={datahorafinalmovimentacao}
                  KeyboardButtonProps={{ padding: 0 }}
                  invalidDateMessage=""
                />
              </Grid>
              <Grid item>
                <Autocomplete
                  fullWidth
                  name="posto"
                  label="codigonomeposto"
                  url="postoscomboios"
                  unique="idposto"
                  title={t('s.geral.postocomboio')}
                  style={{ minWidth: '160px' }}
                  hiddens={[{ name: 'codigonomeposto' }]}
                  getValue={(value) => {
                    setQuantidades([]);
                    if (value.idposto !== null) {
                      setPosto(value.idposto);
                      setPostoObj(value);
                    } else {
                      setPosto(null);
                      setPostoObj(null);
                      setIdbico(null);
                    }
                  }}
                />
              </Grid>
              {(idagrupamento === '1' || idagrupamento === '2') && (
                <Grid item xs={6} sm={12} md="auto">
                  <Combobox
                    fullWidth
                    name="idbico"
                    disabled={!posto}
                    label="bicoprodutobico"
                    url="bicos"
                    unique="idbico"
                    title={t('s.menu.configuracao.bico')}
                    style={{ minWidth: '100px' }}
                    params={{
                      wherefield: ['idposto', 'tipoproduto'],
                      valuewherefield: [
                        posto,
                        idagrupamento === '1' ? 'C' : 'L',
                      ],
                      typewherefield: ['EQUALS', 'EQUALS'],
                    }}
                    getValue={(value) => {
                      setQuantidades([]);
                      if (value.idbico !== null) {
                        setIdbico(value.idbico);
                      } else {
                        setIdbico(null);
                      }
                    }}
                    first={[{ label: 'TODOS', value: '' }]}
                  />
                </Grid>
              )}
              <Grid item xs={6} sm={12} md="auto">
                <Autocomplete
                  fullWidth
                  name="idveiculo"
                  label="idveiculo"
                  url="veiculos"
                  unique="idveiculo"
                  title={t('s.menu.cadastro.veiculo.locomotiva')}
                  style={{ minWidth: '140px' }}
                  getValue={(value) => {
                    setQuantidades([]);
                    if (value.idveiculo !== null) {
                      setIdveiculo(value.idveiculo);
                    } else {
                      setIdveiculo('');
                    }
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={12} md="auto">
                <Select
                  fullWidth
                  name="idagrupamento"
                  label={t('s.cadastro.pitstop.atendimento')}
                  options={optionsAtendimento}
                  defaultValue={idagrupamento}
                  style={{ minWidth: '180px' }}
                  getValue={(value) => {
                    setQuantidades([]);
                    setIdagrupamento(value);
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={12} md="auto">
                <Button
                  size="medium"
                  variant="contained"
                  color="primary"
                  onClick={handlePesquisar}
                  disabled={gravando}
                  loading={loading}
                  fullWidth={false}
                >
                  {t('s.geral.pesquisar')}
                </Button>
              </Grid>
              <Grid item xs={6} sm={12} md="auto">
                <IconButton
                  type="button"
                  startIcon={
                    <PictureAsPdfIcon
                      style={{ color: 'white', width: 20, height: 20 }}
                    />
                  }
                  backgroundColor="#d32f2f"
                  color="white"
                  iconSize={20}
                  onClick={() => handleExport('PDF')}
                  style={{ minWidth: 40, width: 40, maxWidth: 40 }}
                  disabled={quantidades.length === 0 || gravando}
                />
              </Grid>
              <Grid item xs={6} sm={12} md="auto">
                <IconButton
                  type="button"
                  startIcon={
                    <img
                      src={IconExcel}
                      alt="Excel"
                      style={{
                        width: 20,
                        height: 20,
                        filter: 'invert(1)',
                      }}
                    />
                  }
                  backgroundColor="#2e7d32"
                  color="white"
                  iconSize={20}
                  onClick={() => handleExport('EXCEL')}
                  style={{ minWidth: 40, width: 40, maxWidth: 40 }}
                  disabled={quantidades.length === 0 || gravando}
                />
              </Grid>
            </>
          </Grid>
        </Grid>
      </S.DatePickerWrapper>
      <Tabela
        title=""
        cells={cellQuantidade}
        data={quantidades}
        height="80vh"
        size="small"
        onIconClick={handleImprimeCO}
      />
    </>
  );
}

export default RelPitStopQuantidade;
